<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block black-white-theme">
  <mat-card-header>
    <mat-card-title>Aktivnosti</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (activitiesForm) {
      <form [formGroup]="activitiesForm">
        <mat-accordion formArrayName="activities">
          @for (activity of activitiesArray.controls; track activity; let i = $index) {
            <mat-expansion-panel #expansionPanel  [formGroupName]="i">
              <mat-expansion-panel-header class="no-wrap-header">
                <mat-panel-title>
                  {{ activity.value?.name }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="actions">
                <button mat-icon-button color="primary" (click)="closePanel(expansionPanel)" matTooltip="Završi uređivanje aktivnosti" [disabled]="activity.invalid">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="removeActivity(i)" matTooltip="Ukloni aktivnost">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <mat-form-field class="mb-25">
                <mat-label>Naziv aktivnosti</mat-label>
                <input #activityNameInputs  matInput formControlName="name"/>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Opis aktivnosti</mat-label>
                <textarea matInput formControlName="description"></textarea>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Rezultati</mat-label>
                <textarea matInput formControlName="results"></textarea>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Datum početka</mat-label>
                <input matInput [matDatepicker]="startPicker" formControlName="startDate" [max]="activity.get('endDate')?.value || null" />
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Datum završetka</mat-label>
                <input matInput [matDatepicker]="endPicker" formControlName="endDate" [min]="activity.get('startDate')?.value || null" />
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            </mat-expansion-panel>
          }
        </mat-accordion>
        <button mat-raised-button color="primary" (click)="addActivity()" [disabled]="activitiesForm.invalid">Dodaj Aktivnost</button>
      </form>
    }
  </mat-card-content>
</mat-card>